import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const SUPPORTED = ["en", "nl", "no"];

// Multilingual temporarily disabled — English-only public site.
// Set to true (and flip SHOW_LANG_SWITCH in Navigation) to restore EN/NL/NO.
const MULTILINGUAL_ENABLED = false;

// Map hostname suffix → default language
// yuzenya.nl, www.yuzenya.nl → nl
// yuzenya.no → no
// everything else (.com, .host, localhost) → en
const detectLangFromHost = () => {
  if (typeof window === "undefined") return "en";
  const host = (window.location.hostname || "").toLowerCase();
  if (host.endsWith(".nl") || host === "nl") return "nl";
  if (host.endsWith(".no") || host === "no") return "no";
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (!MULTILINGUAL_ENABLED) return "en";
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem("yz_lang");
    if (SUPPORTED.includes(stored)) return stored;
    return detectLangFromHost();
  });

  useEffect(() => {
    window.localStorage.setItem("yz_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: translations[lang] || translations.en,
    }),
    [lang],
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
